// extracted by mini-css-extract-plugin
module.exports = {"BlogWidget":"blog-widget_BlogWidget__jYSKp","Header":"blog-widget_Header__kiOrb","Link":"blog-widget_Link__qdtVc","Cards":"blog-widget_Cards__gqxh0"};